import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Y from '../../../y18n'
import * as productActions from '../../../store/products'
import Styles from '../../../common/styles'

const mapStateToProps = state => ({
  products: state.products
})

const mapDispatchToProps = dispatch => ({
  productActions: bindActionCreators(productActions, dispatch)
})

class DisplayProductDialog extends Component {
  closeFormDialog = () => {
    this.props.productActions.resetDisplay()
  }

  inputChanged = name => e => {
    this.props.productActions.updateDisplay(name, e.target.value)
  }

  submitChanges = (e, product) => {
    e.preventDefault()
    this.props.productActions.setDisplayProduct(product)
  }

  render () {
    const { products, productActions, classes } = this.props
    if (!products.displayProduct) return null

    return (
      <div>
        <Dialog
          open={products.displayProduct && products.displayProduct !== null}
          onClose={() => productActions.resetDisplay()}
          classes={{
            paper: classes.dialogContent
          }}
        >
          <form onSubmit={e => this.submitChanges(e, products.displayProduct)}>
            <DialogTitle>{Y`Set display product`}</DialogTitle>
            <DialogContent>
              <TextField
                margin='normal'
                label={Y`Title`}
                type='text'
                value={products.displayProduct.title || ''}
                onChange={this.inputChanged('title')}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.root,
                    input: classes.input
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.formLabel
                }}
                fullWidth
              />
              <TextField
                margin='normal'
                label={Y`Subheading`}
                type='text'
                value={products.displayProduct.subheading || ''}
                onChange={this.inputChanged('subheading')}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.root,
                    input: classes.input
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.formLabel
                }}
                fullWidth
              />
              <TextField
                margin='normal'
                label={Y`Image path`}
                type='text'
                value={products.displayProduct.imagePath || ''}
                onChange={this.inputChanged('imagePath')}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.root,
                    input: classes.input
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.formLabel
                }}
                fullWidth
              />
              <TextField
                margin='normal'
                label={Y`Description`}
                type='text'
                value={products.displayProduct.description || ''}
                onChange={this.inputChanged('description')}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.root,
                    input: classes.input
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.formLabel
                }}
                fullWidth
              />
              {products.displayProduct.country === 'Finland' &&
                <TextField
                  margin='normal'
                  label={Y`Translation`}
                  type='text'
                  value={products.displayProduct.information || ''}
                  onChange={this.inputChanged('information')}
                  InputProps={{
                    disableUnderline: true,
                    classes: {
                      root: classes.root,
                      input: classes.input
                    }
                  }}
                  InputLabelProps={{
                    shrink: true,
                    className: classes.formLabel
                  }}
                  fullWidth
                />}
              <TextField
                margin='normal'
                label={Y`Product link`}
                type='text'
                value={products.displayProduct.productLink || ''}
                onChange={this.inputChanged('productLink')}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.root,
                    input: classes.input
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.formLabel
                }}
                fullWidth
              />
              <TextField
                margin='normal'
                label={Y`Product link text`}
                type='text'
                value={products.displayProduct.productLinkText || ''}
                onChange={this.inputChanged('productLinkText')}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.root,
                    input: classes.input
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.formLabel
                }}
                fullWidth
              />
              <TextField
                margin='normal'
                label={Y`Price`}
                type='number'
                value={products.displayProduct.price || ''}
                onChange={this.inputChanged('price')}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.root,
                    input: classes.input
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.formLabel
                }}
                fullWidth
              />
              <TextField
                select
                label={Y`Order`}
                value={products.displayProduct.order}
                onChange={this.inputChanged('order')}
                SelectProps={{
                  native: true
                }}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.root,
                    input: classes.input
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.formLabel
                }}
                margin='normal'
                fullWidth
                >
                  {products.displayProduct.order === undefined
                    ? <option key={'default'} value={''}>
                      {Y`Choose display order`}
                    </option>
                    : ''}
                  {[0, 1, 2].map(o => (
                    <option key={o} value={o}>
                      {o+1}
                    </option>
                  ))}
                </TextField>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => productActions.resetDisplay()} style={{ marginRight: '10px' }}>{Y`Cancel`}</Button>
              <Button
                onClick={() => productActions.removeDisplayProduct(products.displayProduct.id)}
                style={{ marginRight: '10px' }}
                color='secondary'
              >{Y`Remove from display`}</Button>
              <Button type='submit' variant='raised' color='primary' style={{ color: '#fff' }}>
                {Y`Save`}
              </Button>
            </DialogActions>
          </form>
        </Dialog>
      </div>
    )
  }
}

DisplayProductDialog = connect(mapStateToProps, mapDispatchToProps)(DisplayProductDialog)
export default withStyles(Styles)(DisplayProductDialog)



// WEBPACK FOOTER //
// ./src/pages/products/containers/display-product-dialog.js